// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconPlaceholderPath = 'M15.024 14.864 11.245 9.96l3.743-4.86a6.978 6.978 0 0 1 .034 9.765Zm-8.489 1.21 3.448-4.477 3.458 4.491a6.942 6.942 0 0 1-6.906-.014ZM3 10a6.97 6.97 0 0 1 1.992-4.88l3.73 4.84-3.763 4.883A6.962 6.962 0 0 1 3 10Zm10.4-6.115L9.982 8.321 6.578 3.9A6.95 6.95 0 0 1 10.001 3c1.232 0 2.392.323 3.399.885ZM10 1c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Z';
var IconPlaceholder = baseIcon('IconPlaceholder', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconPlaceholderPath
});
export default IconPlaceholder;
//# sourceMappingURL=index.js.map